import React, { useEffect, useReducer } from "react";
import { useLocation, useHistory } from 'react-router-dom';
import InnerHTML from "../base/InnerHtml";
import { useConsenstString } from "./Web2mediaHooks"; // Assuming this is the correct import path
import { getCookie } from "~/utility/cookies";

const Banner = () => {
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  const location = useLocation();
  const history = useHistory();
  // Generate a key to force remount based on the current location
  const forceRemountKey = location.pathname + location.search;

  useEffect(() => {
    // Directly inject or reinject the script tag
    const scriptTag = document.createElement('script');
    scriptTag.src = '//cdn.web2media.sk/adasync.min.js';
    scriptTag.async = true;
    scriptTag.type = 'text/javascript';
  
    document.body.appendChild(scriptTag);

    console.log("SCRIPT TAG: ", scriptTag);
  
    return () => {
      // Remove the script tag on cleanup to avoid duplicates or reinitialize state
      document.body.removeChild(scriptTag);   
      console.log('removed SCRIPT TAG');
    };
  }, [forceRemountKey]);


  // Fetch the consent string for GDPR compliance
  const consentString = getCookie("euconsent-v2") || '';
  // Parameters for the custom hook to generate the ad content
  const firstPartConsent = '<ins class="asm_async_creative" style="display:inline-block; width:1px; height:1px;text-align:left; text-decoration:none;" data-asm-cdn="cdn.web2media.sk" data-asm-host="turbo.web2media.sk" data-asm-params="pid=715&gdpr_consent=[';
  const lastPartConsent = ']"></ins>';
  // Use the custom hook to dynamically generate the HTML string for the ad, including the consent string
  const htmlConsentString = useConsenstString(firstPartConsent, consentString, lastPartConsent);

  return (
    <div className="banner-wrapper">
      <InnerHTML
        key={forceRemountKey} // Force re-mounting on location change to update ads
        html={htmlConsentString}
      />
    </div>
  );
};
export const Web2MediaDesktopSkinny = Banner;

export default Banner;
